import React, { useEffect, useRef, useState } from 'react'

export default function FilterOptionsScroll({ children, className = '' }) {
  const optionsRef = useRef(null);
  const [scrollState, setScrollState] = useState({
    isScrollable: false,
    hasMoreBelow: false,
  });

  useEffect(() => {
    const options = optionsRef.current;

    if (!options) {
      return undefined;
    }

    let frameId = null;

    const updateScrollState = () => {
      const maxScrollTop = options.scrollHeight - options.clientHeight;
      const isScrollable = maxScrollTop > 2;
      const hasMoreBelow = isScrollable && options.scrollTop < maxScrollTop - 2;

      setScrollState((currentState) => {
        if (
          currentState.isScrollable === isScrollable &&
          currentState.hasMoreBelow === hasMoreBelow
        ) {
          return currentState;
        }

        return { isScrollable, hasMoreBelow };
      });
    };

    const scheduleUpdate = () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      frameId = window.requestAnimationFrame(updateScrollState);
    };

    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(scheduleUpdate)
      : null;
    const mutationObserver = typeof MutationObserver !== 'undefined'
      ? new MutationObserver(scheduleUpdate)
      : null;

    scheduleUpdate();
    options.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
    resizeObserver?.observe(options);
    mutationObserver?.observe(options, {
      childList: true,
      subtree: true,
    });

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      options.removeEventListener('scroll', scheduleUpdate);
      window.removeEventListener('resize', scheduleUpdate);
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
    };
  }, []);

  const shellClassName = [
    'retro-filter-options-shell',
    scrollState.isScrollable ? 'is-scrollable' : '',
    scrollState.hasMoreBelow ? 'has-scroll-hint' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={shellClassName}>
      <div className="retro-filter-options" ref={optionsRef}>
        {children}
      </div>
      <div className="retro-filter-scroll-hint" aria-hidden="true">
        <i className="feather-chevron-down"></i>
      </div>
    </div>
  )
}
